/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Going to be required in future. Type of the device as whole system. AO §146a art  DeviceType:  * `PC_POS` - Computerized/PC POS system  * `APP_POS` - Tablet/app POS system  * `CASH_REGISTER` - Electronic cash register  * `TAXIMETER` - Taximeter  * `DISTANCE_COUNTER` - Distance counter 
 */
export enum ErsDeviceTypeEnumDTO {
    PC_POS = 'PC_POS',
    APP_POS = 'APP_POS',
    CASH_REGISTER = 'CASH_REGISTER',
    TAXIMETER = 'TAXIMETER',
    DISTANCE_COUNTER = 'DISTANCE_COUNTER'
}

export class ClsErsDeviceTypeEnumDTO {
    PC_POS = 'PC_POS';
    APP_POS = 'APP_POS';
    CASH_REGISTER = 'CASH_REGISTER';
    TAXIMETER = 'TAXIMETER';
    DISTANCE_COUNTER = 'DISTANCE_COUNTER';
}

